<div class="song" [class.song_status_playing]="melody.isPlaying">
  <div class="song__cover">
    <img [src]="melody.pictureUrlSmall" [alt]="melody.title + ',' + melody.artistTitle" appReplaceMissingImage/>
    <div class="song__player" (click)="play()">
      <div class="player player_size_">
        <div class="player__button icon-play" [class.icon-pause]="melody.isPlaying"></div>
        <div class="player__progressbar" #progressBar></div>
      </div>
    </div>
  </div>
  <div class="song__content">
    <div class="song__name">
      <a [routerLink]="'/melodies/' + melody.melodyMarketplaceId" class="song__name-link">{{melody.title}}</a>
    </div>
    <div class="song__artist">
      <a [routerLink]="'/artists/' + melody.artistId" class="song__artist-link">{{melody.artistTitle}}</a>
    </div>
  </div>
  <div class="song__controls">
    <div class="song__control" [class.icon-star]="!melody.favorite" [class.icon-star-filled]="melody.favorite" (click)="toggleFavorite()"></div>
    <div class="song__control icon-download" *ngIf="!purchased" (click)="purchaseMelody()"></div>
  </div>
</div>
